import Vue from 'vue'
import 'vue-progress-path/dist/vue-progress-path.css'
// @ts-ignore
import VueProgress from 'vue-progress-path'

Vue.use(VueProgress)
